import {
  Card,
  Flex,
  Skeleton,
  Space,
  Spacing,
  Typography,
} from "@p0security/ui";
import { useCallback, useState } from "react";
import { colors } from "styles/variables";

import { ShowMore } from "./common/ShowMore";

export const Pane: React.FC<{
  children?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: string;

  showMore?: {
    text: string;
    onClick: () => void;
  };
  style?: React.CSSProperties;
  tooltipPayload?: React.ReactNode;
  isLoading?: boolean;
  subtitleType?: "text" | "title";
  additionalControls?: React.ReactNode;
}> = ({
  children,
  subtitle,
  title,
  showMore,
  style,
  tooltipPayload,
  isLoading,
  subtitleType = "title",
  additionalControls,
}) => {
  const [showButton, setShowButton] = useState(false);
  const handleMouseEnter = useCallback(
    (_event: React.MouseEvent<HTMLDivElement>) => setShowButton(true),
    [setShowButton]
  );
  const handleMouseLeave = useCallback(
    (_event: React.MouseEvent<HTMLDivElement>) => setShowButton(false),
    [setShowButton]
  );

  return (
    <Card
      className="info-pane [&_.ant-card-body]:h-full! [&_.ant-card-body]:p-3!"
      /* eslint-disable-line react/forbid-component-props */ style={{
        borderRadius: "4px",
        border: `1px solid ${colors.neutral["15"]}`,
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        height: "100%",
        overflowY: "hidden",
        overflowX: "hidden",
        padding: "0px",
        ...style,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Flex className="h-full w-full" gap={3} vertical>
        <Space className="w-full justify-between">
          <Space
            /* eslint-disable-line react/forbid-component-props */ style={{
              alignContent: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {isLoading ? (
              <Skeleton.Input active />
            ) : (
              <Spacing asChild my={0}>
                <Typography.Title level={4} ellipsis={{ rows: 2 }}>
                  {title}
                </Typography.Title>
              </Spacing>
            )}
            {tooltipPayload}
            {additionalControls && (
              <Flex align="center" gap="small">
                {additionalControls}
              </Flex>
            )}
          </Space>
          <Flex align="center">
            {showMore && (
              <ShowMore
                visible={showButton}
                text={showMore.text}
                onClick={showMore.onClick}
              />
            )}
          </Flex>
        </Space>

        {!isLoading &&
          (subtitleType === "title" ? (
            <Spacing asChild mt={0}>
              <Typography.Title
                /* eslint-disable-line react/forbid-component-props */ style={{
                  color: `${colors.neutral["40"]}`,
                }}
                level={5}
              >
                {subtitle}
              </Typography.Title>
            </Spacing>
          ) : (
            <Typography.Text>{subtitle}</Typography.Text>
          ))}
        {children}
      </Flex>
    </Card>
  );
};
